/**
 *
 * Asynchronously loads the component for PatientDataPage
 *
 */

import loadable from "@loadable/component";

export default loadable(() => import("./DentistDataPage"));
